(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wheel_addon"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window._cwAddonBound) return;
    window._cwAddonBound = true;

    // Selection lives in the DOM so Turbo visits between products never carry a stale state.
    function selectedOption() {
      var input = document.querySelector('.cw-addon__input:checked');
      return input ? input.value : 'wheel-only';
    }

    function pushEvent(name) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'proteus_custom_event',
        proteus_event_name: name,
        proteus_event_category: 'CRO',
        page_location: window.location.href
      });
    }

    // Totals are rendered by Liquid in the visitor's market currency, so only text is swapped here.
    function updatePagePrice(root, option) {
      var withBase = option === 'with-base';
      document.querySelectorAll('#chirpProductPrice strong.text-chirp-blue-dark').forEach(function (el) {
        el.textContent = withBase ? root.dataset.priceTotal : root.dataset.priceWheel;
      });
      document.querySelectorAll('#chirpProductPrice s').forEach(function (el) {
        el.textContent = withBase ? root.dataset.compareTotal : root.dataset.compareWheel;
      });
    }

    // The desktop and mobile copies are separate radio groups; keep them on the same choice.
    document.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.classList || !input.classList.contains('cw-addon__input')) return;
      document.querySelectorAll('.cw-addon__input').forEach(function (other) {
        if (other.value === input.value) other.checked = true;
      });
      updatePagePrice(input.closest('.cw-addon'), input.value);
      pushEvent('[CHRP-20] select: ' + input.value);
    });

    var pendingOption = null;

    document.addEventListener('product-form:items', function (e) {
      pendingOption = null;
      var root = document.querySelector('.cw-addon');
      var items = e.detail && e.detail.items;
      if (!root || !items || !items.length) return;
      if (root.dataset.variantIds.split(',').indexOf(String(items[0].id)) === -1) return;

      pendingOption = selectedOption();
      if (pendingOption === 'with-base') {
        items.push({ id: Number(root.dataset.addonVariantId), quantity: 1 });
      }
    });

    document.addEventListener('cart:updated', function () {
      if (!pendingOption) return;
      pushEvent('[CHRP-20] ATC: ' + pendingOption);
      pendingOption = null;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
